import Event from './Event';
import LocalStorage from '../local_data';

class GetCartProducts extends Event {
    eventName = 'oms_getCartProducts';

    
    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for get selected cart products
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId) {
            let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
            let selectedProducts = new LocalStorage.CartLocation(currentLocation).getData();

            if (selectedProducts) {
                Object.keys(selectedProducts).forEach(function (key) {
                    selectedProducts[key].id = key;
                });
            }

            this.onSuccessEvent({
                data: selectedProducts
            },  {
                'action' : action, 
                'request_id' : requestId 
            });
        }
        else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetCartProducts;